import { render } from "./ProjectProgressBar.vue?vue&type=template&id=5a4f7511"
import script from "./ProjectProgressBar.vue?vue&type=script&lang=js"
export * from "./ProjectProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__